/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type BadgeZoneViolationEvent,
    BadgeZoneViolationEventFromJSON,
    BadgeZoneViolationEventToJSON,
} from '../models/BadgeZoneViolationEvent';
import {
    type BadgeZoneViolationEventCreate,
    BadgeZoneViolationEventCreateFromJSON,
    BadgeZoneViolationEventCreateToJSON,
} from '../models/BadgeZoneViolationEventCreate';
import {
    type BadgeZoneViolationIncident,
    BadgeZoneViolationIncidentFromJSON,
    BadgeZoneViolationIncidentToJSON,
} from '../models/BadgeZoneViolationIncident';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';

export interface BadgeZoneViolationEventsCreateBadgeZoneViolationEventRequest {
    badgeZoneViolationEventCreate: BadgeZoneViolationEventCreate;
}

export interface BadgeZoneViolationEventsReadBadgeZoneViolationEventRequest {
    eventId: string;
}

export interface BadgeZoneViolationEventsReadBadgeZoneViolationIncidentRequest {
    id: string;
}

/**
 * BadgeZoneViolationEventsApi - interface
 * 
 * @export
 * @interface BadgeZoneViolationEventsApiInterface
 */
export interface BadgeZoneViolationEventsApiInterface {
    /**
     * Creates request options for badgeZoneViolationEventsCreateBadgeZoneViolationEvent without sending the request
     * @param {BadgeZoneViolationEventCreate} badgeZoneViolationEventCreate 
     * @throws {RequiredError}
     * @memberof BadgeZoneViolationEventsApiInterface
     */
    badgeZoneViolationEventsCreateBadgeZoneViolationEventRequestOpts(requestParameters: BadgeZoneViolationEventsCreateBadgeZoneViolationEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new badge zone violation event
     * @summary Create a badge zone violation event
     * @param {BadgeZoneViolationEventCreate} badgeZoneViolationEventCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgeZoneViolationEventsApiInterface
     */
    badgeZoneViolationEventsCreateBadgeZoneViolationEventRaw(requestParameters: BadgeZoneViolationEventsCreateBadgeZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BadgeZoneViolationEvent>>;

    /**
     * Create a new badge zone violation event
     * Create a badge zone violation event
     */
    badgeZoneViolationEventsCreateBadgeZoneViolationEvent(requestParameters: BadgeZoneViolationEventsCreateBadgeZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BadgeZoneViolationEvent>;

    /**
     * Creates request options for badgeZoneViolationEventsReadBadgeZoneViolationEvent without sending the request
     * @param {string} eventId 
     * @throws {RequiredError}
     * @memberof BadgeZoneViolationEventsApiInterface
     */
    badgeZoneViolationEventsReadBadgeZoneViolationEventRequestOpts(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns a single badge zone violation event by given ID
     * @summary Get a single badge zone violation event
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgeZoneViolationEventsApiInterface
     */
    badgeZoneViolationEventsReadBadgeZoneViolationEventRaw(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BadgeZoneViolationEvent>>;

    /**
     * Returns a single badge zone violation event by given ID
     * Get a single badge zone violation event
     */
    badgeZoneViolationEventsReadBadgeZoneViolationEvent(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BadgeZoneViolationEvent>;

    /**
     * Creates request options for badgeZoneViolationEventsReadBadgeZoneViolationIncident without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof BadgeZoneViolationEventsApiInterface
     */
    badgeZoneViolationEventsReadBadgeZoneViolationIncidentRequestOpts(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationIncidentRequest): Promise<runtime.RequestOpts>;

    /**
     * Retrieve a single badge zone violation incident by ID.
     * @summary Read a badge zone violation incident
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgeZoneViolationEventsApiInterface
     */
    badgeZoneViolationEventsReadBadgeZoneViolationIncidentRaw(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BadgeZoneViolationIncident>>;

    /**
     * Retrieve a single badge zone violation incident by ID.
     * Read a badge zone violation incident
     */
    badgeZoneViolationEventsReadBadgeZoneViolationIncident(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BadgeZoneViolationIncident>;

}

/**
 * 
 */
export class BadgeZoneViolationEventsApi extends runtime.BaseAPI implements BadgeZoneViolationEventsApiInterface {

    /**
     * Creates request options for badgeZoneViolationEventsCreateBadgeZoneViolationEvent without sending the request
     */
    async badgeZoneViolationEventsCreateBadgeZoneViolationEventRequestOpts(requestParameters: BadgeZoneViolationEventsCreateBadgeZoneViolationEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['badgeZoneViolationEventCreate'] == null) {
            throw new runtime.RequiredError(
                'badgeZoneViolationEventCreate',
                'Required parameter "badgeZoneViolationEventCreate" was null or undefined when calling badgeZoneViolationEventsCreateBadgeZoneViolationEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/badge_zone_violation_events/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BadgeZoneViolationEventCreateToJSON(requestParameters['badgeZoneViolationEventCreate']),
        };
    }

    /**
     * Create a new badge zone violation event
     * Create a badge zone violation event
     */
    async badgeZoneViolationEventsCreateBadgeZoneViolationEventRaw(requestParameters: BadgeZoneViolationEventsCreateBadgeZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BadgeZoneViolationEvent>> {
        const requestOptions = await this.badgeZoneViolationEventsCreateBadgeZoneViolationEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BadgeZoneViolationEventFromJSON(jsonValue));
    }

    /**
     * Create a new badge zone violation event
     * Create a badge zone violation event
     */
    async badgeZoneViolationEventsCreateBadgeZoneViolationEvent(requestParameters: BadgeZoneViolationEventsCreateBadgeZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BadgeZoneViolationEvent> {
        const response = await this.badgeZoneViolationEventsCreateBadgeZoneViolationEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for badgeZoneViolationEventsReadBadgeZoneViolationEvent without sending the request
     */
    async badgeZoneViolationEventsReadBadgeZoneViolationEventRequestOpts(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling badgeZoneViolationEventsReadBadgeZoneViolationEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/badge_zone_violation_events/{event_id}`;
        urlPath = urlPath.replace('{event_id}', encodeURIComponent(String(requestParameters['eventId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a single badge zone violation event by given ID
     * Get a single badge zone violation event
     */
    async badgeZoneViolationEventsReadBadgeZoneViolationEventRaw(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BadgeZoneViolationEvent>> {
        const requestOptions = await this.badgeZoneViolationEventsReadBadgeZoneViolationEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BadgeZoneViolationEventFromJSON(jsonValue));
    }

    /**
     * Returns a single badge zone violation event by given ID
     * Get a single badge zone violation event
     */
    async badgeZoneViolationEventsReadBadgeZoneViolationEvent(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BadgeZoneViolationEvent> {
        const response = await this.badgeZoneViolationEventsReadBadgeZoneViolationEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for badgeZoneViolationEventsReadBadgeZoneViolationIncident without sending the request
     */
    async badgeZoneViolationEventsReadBadgeZoneViolationIncidentRequestOpts(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationIncidentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling badgeZoneViolationEventsReadBadgeZoneViolationIncident().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/badge_zone_violation_events/incident/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve a single badge zone violation incident by ID.
     * Read a badge zone violation incident
     */
    async badgeZoneViolationEventsReadBadgeZoneViolationIncidentRaw(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BadgeZoneViolationIncident>> {
        const requestOptions = await this.badgeZoneViolationEventsReadBadgeZoneViolationIncidentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BadgeZoneViolationIncidentFromJSON(jsonValue));
    }

    /**
     * Retrieve a single badge zone violation incident by ID.
     * Read a badge zone violation incident
     */
    async badgeZoneViolationEventsReadBadgeZoneViolationIncident(requestParameters: BadgeZoneViolationEventsReadBadgeZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BadgeZoneViolationIncident> {
        const response = await this.badgeZoneViolationEventsReadBadgeZoneViolationIncidentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
